import type { Resource } from '../../';
export const country_countries_IS: Resource = {"default":"Iceland"};
